import { VInput } from 'vuetify/lib/components/VInput';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    VInput,
    {
      ref: "vinput",
      staticClass: "df-datepicker",
      attrs: { value: _vm.model, rules: _vm.rules },
    },
    [
      _c("NsDatePicker", {
        staticClass: "df-datepicker-field",
        attrs: {
          label: _vm.schema.label,
          locale: _vm.dateLocale,
          clearable: !_vm.schema.required,
        },
        on: { shown: _vm.handleShown },
        model: {
          value: _vm.model,
          callback: function ($$v) {
            _vm.model = $$v
          },
          expression: "model",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }